import { SidebarIcon, type SidebarIconProps } from "./sidebar-icon";

export const SidebarRightOpenIcon = (props: SidebarIconProps) => (
  <SidebarIcon side="right" open={true} {...props} />
);
